module.exports = __webpack_public_path__ + "fonts/rubik-bold-webfont.4c728ecd.4c728ecd.woff";